import {
  IconAperture,
  IconUsers,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconBuildingFactory,
  IconCategory,
  IconLock,
  IconBasket,
  IconScale,
  IconTruckLoading,
  IconBuildingBank,
  IconCreditCard,
  IconCoin,
  IconTransferOut,
  IconTransfer,
  IconPackages,
  IconBasketDollar,
  IconClipboardText,
  IconRestore,
  IconReport,
  IconUsersGroup,
  IconBrandProducthunt,
  IconHomeCog,
  IconBasketCog,
  IconTruckReturn,
  IconUserCog,
  IconBox,
  IconContract,
  IconReceipt2,
  IconCircleCheck,
  IconReportMoney,
  IconArrowsTransferUpDown
} from '@tabler/icons-react';

import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { uniqueId } from 'lodash';
import { canManageProductActions, hasPermission, hasYangonRegionAccess } from 'src/lib/utils';

import {

  CATEGORY_LIST_SK,
  FINISHED_GOOD_LIST_SK,
  PERMISSION_LIST_SK,
  PRODUCTION_LIST_SK,
  PURCHASE_LIST_SK,
  RAW_MATERIAL_LIST_SK,
  ROLE_LIST_SK,
  SHOP_LIST_SK,
  SUPPLIER_LIST_SK,
  UOM_CONVERSION_LIST_SK,
  UOM_LIST_SK,
  USER_LIST_SK,
  WAREHOUSE_LIST_SK,
  INVENTORY_LIST_SK,
  ORDER_LIST_SK,
  SALE_LIST_SK,
  STOCK_RETURN_LIST_SK,
  ORDER_REPORT_LIST_SK,
  SALE_REPORT_LIST_SK,
  PURCHASE_REPORT_LIST_SK,
  BRAND_LIST_SK,
  REGION_LIST_SK,
  PRODUCTION_ORDER_LIST_SK,
  BILL_REPORT_LIST_SK,
  PAYMENT_REPORT_LIST_SK,
  DAILY_STOCK_SUMMARY_REPORT_LIST_SK,
  DAILY_INVENTORY_VALUATION_REPORT_LIST_SK,
  ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK,
  PURCHASE_HISTORY_LIST_SK,
  INTERNAL_TRANSFER_LIST_SK,
  WAREHOUSE_ORDER_LIST_SK,
  STOCK_ADJUSTMENT_LIST_SK,
  STOCK_MOVEMENT_LIST_SK,
  STOCK_MOVEMENT_REPORT_LIST_SK,
  EXPENSE_LIST_SK,
  EXPENSE_HEADER_LIST_SK,
  EXPENSE_SUBHEADER_LIST_SK,
  WAREHOUSE_CONSUMPTION_LIST_SK,
  PRICE_CHANGE_SK,
  CONSUMPTION_TYPE_LIST_SK,
  PAR_LEVEL_LIST_SK,
  BILL_LIST_SK,
  PAYMENT_LIST_SK,
} from 'src/lib/constants';
import { IconAdjustments, IconBadge, IconHistory, IconMapPin } from '@tabler/icons';

const getMenuItems = (userPermissions, isRootAdmin, user) =>
  [
    {
      navlabel: true,
      icon: IconReport,
      subheader: 'Reports',
      permission: [
        ORDER_REPORT_LIST_SK,
        SALE_REPORT_LIST_SK,
        ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK,
        STOCK_MOVEMENT_REPORT_LIST_SK,
        DAILY_STOCK_SUMMARY_REPORT_LIST_SK,
        DAILY_INVENTORY_VALUATION_REPORT_LIST_SK,
        PURCHASE_REPORT_LIST_SK,
        BILL_REPORT_LIST_SK,
        PAYMENT_REPORT_LIST_SK,
      ].some((perm) => hasPermission(userPermissions, perm, isRootAdmin)) || isRootAdmin,
      items: [
        {
          id: uniqueId(),
          title: 'Dashboard',
          icon: IconAperture,
          href: '/dashboard',
          // Intentional authenticated-only (no backend dashboard permission).
          permission: true,
        },
        {
          id: uniqueId(),
          title: 'Stock',
          icon: IconReport,
          href: '/reports/stock-pivot',
          permission: hasPermission(userPermissions, STOCK_MOVEMENT_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Stock Summary',
          icon: IconReport,
          href: '/reports/daily-stock-summary',
          permission: hasPermission(userPermissions, DAILY_STOCK_SUMMARY_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Inventory Valuation',
          icon: IconReport,
          href: '/reports/daily-inventory-valuation',
          permission: hasPermission(userPermissions, DAILY_INVENTORY_VALUATION_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Production Balance',
          icon: IconReport,
          href: '/reports/estimated-production-balance',
          permission: hasPermission(userPermissions, ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'အော်ဒါများ',
          icon: IconClipboardText,
          href: '/reports/orders',
          permission: hasPermission(userPermissions, ORDER_REPORT_LIST_SK, isRootAdmin),
        },
        // {
        //   id: uniqueId(),
        //   title: 'Stock & Order Summary',
        //   icon: IconReport,
        //   href: '/reports/stock-order-summary',
        //   permission: hasPermission(userPermissions, STOCK_ORDER_SUMMARY_REPORT_LIST_SK, isRootAdmin),
        // },

        {
          id: uniqueId(),
          title: 'အရောင်းများ',
          icon: IconBasketDollar,
          href: '/reports/sales',
          permission: hasPermission(userPermissions, SALE_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ဝယ်ယူမှုများ',
          icon: IconBasket,
          href: '/reports/purchase-pivot',
          permission: hasPermission(userPermissions, PURCHASE_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ဘေလ်များ',
          icon: IconReceipt2,
          href: '/reports/bills-pivot',
          permission: hasPermission(userPermissions, BILL_REPORT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ပေးချေမှုများ',
          icon: IconReportMoney,
          href: '/reports/payments-made',
          permission: hasPermission(userPermissions, PAYMENT_REPORT_LIST_SK, isRootAdmin),
        },
        // {
        //   id: uniqueId(),
        //   title: 'Stock Movements',
        //   icon: IconArrowsTransferUpDown,
        //   href: '/reports/stock-movement-pivot',
        //   permission: hasPermission(userPermissions, STOCK_MOVEMENT_REPORT_LIST_SK, isRootAdmin),
        // },

        // {
        //   id: uniqueId(),
        //   title: 'Professional Sales Pivot',
        //   icon: IconBasketDollar,
        //   href: '/reports/sales-pivot',
        //   permission: hasPermission(userPermissions, SALE_REPORT_LIST_SK, isRootAdmin),
        // },
      ],
    },
    {
      navlabel: true,
      icon: IconUserCog,
      subheader: 'အသုံးပြုသူ စီမံမှု',
      permission: [PERMISSION_LIST_SK, ROLE_LIST_SK, USER_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [
        {
          id: uniqueId(),
          title: 'ခွင့်ပြုချက်များ',
          icon: IconLock,
          href: '/permissions',
          permission: hasPermission(userPermissions, PERMISSION_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'အသုံးပြုသူအဆင့်များ',
          icon: IconUsers,
          href: '/roles',
          permission: hasPermission(userPermissions, ROLE_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'အသုံးပြုသူများ',
          icon: ManageAccountsOutlinedIcon,
          href: '/users',
          permission: hasPermission(userPermissions, USER_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconBox,
      subheader: 'ကုန်ပစ္စည်းများ',
      permission: [
        RAW_MATERIAL_LIST_SK,
        FINISHED_GOOD_LIST_SK,
        PRODUCTION_LIST_SK,
        CATEGORY_LIST_SK,
        PAR_LEVEL_LIST_SK,
      ].some((perm) => hasPermission(userPermissions, perm, isRootAdmin))
        || (hasPermission(userPermissions, PRICE_CHANGE_SK, isRootAdmin)
          && canManageProductActions(user)),
      items: [
        {
          id: uniqueId(),
          title: 'ကုန်ကြမ်းပစ္စည်းများ',
          icon: IconTruckLoading,
          href: '/raw-materials',
          permission: hasPermission(userPermissions, RAW_MATERIAL_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ကုန်ချောများ',
          icon: IconPackages,
          href: '/finished-goods',
          permission: hasPermission(userPermissions, FINISHED_GOOD_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Price List',
          icon: IconBasketDollar,
          href: '/price-list',
          permission: hasPermission(userPermissions, PRICE_CHANGE_SK, isRootAdmin)
            && canManageProductActions(user),
        },
        {
          id: uniqueId(),
          title: 'Standard Cost History',
          icon: IconBasketDollar,
          href: '/standard-cost-history',
          permission: hasPermission(userPermissions, PRICE_CHANGE_SK, isRootAdmin)
            && canManageProductActions(user),
        },
        // {
        //   id: uniqueId(),
        //   title: 'ထုတ်လုပ်မှုများ',
        //   icon: IconBuildingFactory,
        //   href: '/productions',
        //   permission: hasPermission(userPermissions, PRODUCTION_LIST_SK, isRootAdmin),
        // },
        {
          id: uniqueId(),
          title: 'PAR Levels',
          icon: IconBasketCog,
          href: '/par-levels',
          permission: hasPermission(userPermissions, PAR_LEVEL_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'အမျိုးအစားများ',
          icon: IconCategory,
          href: '/categories',
          permission: hasPermission(userPermissions, CATEGORY_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconBasketCog,
      subheader: 'ဝယ်ယူမှုများ',
      permission: [PURCHASE_LIST_SK, BILL_LIST_SK, PAYMENT_LIST_SK, PURCHASE_HISTORY_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [
        {
          id: uniqueId(),
          title: 'ဝယ်ယူမှုများ',
          icon: IconBasket,
          href: '/purchases',
          permission: hasPermission(userPermissions, PURCHASE_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Purchase History',
          icon: IconCreditCard,
          href: '/purchase-history',
          permission: hasPermission(userPermissions, PURCHASE_HISTORY_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ပေးရန်ရှိသော ဘေလ်များ',
          icon: IconReceipt2,
          href: '/bills/unpaid',
          permission: hasPermission(userPermissions, BILL_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ပေးချေပြီးသော ဘေလ်များ',
          icon: IconCircleCheck,
          href: '/bills/paid',
          permission: hasPermission(userPermissions, BILL_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ငွေပေးချေမှုများ',
          icon: IconReportMoney,
          href: '/payments',
          permission: hasPermission(userPermissions, PAYMENT_LIST_SK, isRootAdmin),
        },
        // {
        //   id: uniqueId(),
        //   title: 'အကြွေးပေးချေမှုများ',
        //   icon: IconCoin,
        //   href: '/credit-payments',
        //   permission: hasPermission(userPermissions, CREDIT_PAYMENT_LIST_SK, isRootAdmin),
        // },
      ],
    },

    {
      navlabel: true,
      icon: IconBuildingWarehouse,
      subheader: 'ကုန်စာရင်း',
      permission: [
        INVENTORY_LIST_SK,
        INTERNAL_TRANSFER_LIST_SK,
        STOCK_ADJUSTMENT_LIST_SK,
        STOCK_MOVEMENT_LIST_SK,
      ].some((perm) => hasPermission(userPermissions, perm, isRootAdmin))
        || (hasPermission(userPermissions, PRODUCTION_ORDER_LIST_SK, isRootAdmin)
          && hasYangonRegionAccess(user)),
      items: [
        {
          id: uniqueId(),
          title: 'ကုန်စာရင်း',
          icon: IconBuildingStore,
          href: '/stock-list',
          permission: hasPermission(userPermissions, INVENTORY_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ထုတ်လုပ်မှုများ',
          icon: IconBuildingFactory,
          href: '/production-orders',
          permission: hasPermission(userPermissions, PRODUCTION_ORDER_LIST_SK, isRootAdmin)
            && hasYangonRegionAccess(user),
        },
        // {
        //   id: uniqueId(),
        //   title: 'Stock List',
        //   icon: IconBuildingStore,
        //   href: '/stock-list',
        //   permission: INVENTORY_LIST_SK,
        // },
        {
          id: uniqueId(),
          title: 'ကုန်စာရင်းလွှဲပြောင်းမှုများ',
          icon: IconTransfer,
          href: '/internal-transfers',
          permission: hasPermission(userPermissions, INTERNAL_TRANSFER_LIST_SK, isRootAdmin),
        },
        // Hidden: Stock Request is outside the Internal Transfer / Warehouse Order architecture.
        // {
        //   id: uniqueId(),
        //   title: 'Stock Requests',
        //   icon: IconPackages,
        //   href: '/stock-requests',
        //   permission: hasPermission(userPermissions, STOCK_REQUEST_LIST_SK, isRootAdmin),
        // },
        {
          id: uniqueId(),
          title: 'Stock Adjustments',
          icon: IconAdjustments,
          href: '/stock-adjustments',
          permission: hasPermission(userPermissions, STOCK_ADJUSTMENT_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Moves History',
          icon: IconHistory,
          href: '/stock-movements',
          permission: hasPermission(userPermissions, STOCK_MOVEMENT_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconBuildingWarehouse,
      subheader: 'ဂိုဒေါင်အမှာများ',
      permission: [WAREHOUSE_ORDER_LIST_SK].some((perm) => hasPermission(userPermissions, perm, isRootAdmin)),
      items: [
        {
          id: uniqueId(),
          title: 'Warehouse Orders',
          icon: IconClipboardText,
          href: '/warehouse-orders',
          permission: hasPermission(userPermissions, WAREHOUSE_ORDER_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconContract,
      subheader: 'အော်ဒါများ',
      permission: [ORDER_LIST_SK].some((perm) => hasPermission(userPermissions, perm, isRootAdmin)),
      items: [
        {
          id: uniqueId(),
          title: 'အော်ဒါများ',
          icon: IconClipboardText,
          href: '/orders',
          permission: hasPermission(userPermissions, ORDER_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Backorders',
          icon: IconClipboardText,
          href: '/backorders',
          permission: hasPermission(userPermissions, ORDER_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ဆိုင်လက်ကျန်များ',
          icon: IconClipboardText,
          href: '/shop-balance',
          permission: hasPermission(userPermissions, ORDER_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ကွာဟချက်များ',
          icon: IconClipboardText,
          href: '/discrepancies',
          permission: hasPermission(userPermissions, ORDER_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconBasketDollar,
      subheader: 'အရောင်းများ',
      permission: [SALE_LIST_SK].some((perm) => hasPermission(userPermissions, perm, isRootAdmin)),
      items: [
        {
          id: uniqueId(),
          title: 'အရောင်းများ',
          icon: IconBasketDollar,
          href: '/sales',
          permission: hasPermission(userPermissions, SALE_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconTruckReturn,
      subheader: 'ဆိုင်မှပြန်ပေးစာရင်း',
      permission: hasPermission(userPermissions, STOCK_RETURN_LIST_SK, isRootAdmin),
      items: [
        {
          id: uniqueId(),
          title: 'ဆိုင်မှပြန်ပေးစာရင်းများ',
          icon: IconTruckReturn,
          href: '/stock-returns',
          permission: hasPermission(userPermissions, STOCK_RETURN_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconReceipt2,
      subheader: 'ဂိုဒေါင်သုံးစွဲမှုများ',
      permission: [WAREHOUSE_CONSUMPTION_LIST_SK, CONSUMPTION_TYPE_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [
        {
          id: uniqueId(),
          title: 'ဂိုဒေါင်သုံးစွဲမှုများ',
          icon: IconCoin,
          href: '/warehouse-consumptions',
          permission: hasPermission(userPermissions, WAREHOUSE_CONSUMPTION_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'သုံးစွဲပစ္စည်းစာရင်း',
          icon: IconClipboardText,
          href: '/consumption-items',
          permission: hasPermission(userPermissions, WAREHOUSE_CONSUMPTION_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Consumption Types',
          icon: IconCategory,
          href: '/consumption-types',
          permission: hasPermission(userPermissions, CONSUMPTION_TYPE_LIST_SK, isRootAdmin),
        },
      ]

    },
    {
      navlabel: true,
      icon: IconReceipt2,
      subheader: 'အသုံးစရိတ်များ',
      permission: [EXPENSE_LIST_SK, EXPENSE_HEADER_LIST_SK, EXPENSE_SUBHEADER_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [

        {
          id: uniqueId(),
          title: 'အသုံးစရိတ်များ',
          icon: IconCoin,
          href: '/expenses',
          permission: hasPermission(userPermissions, EXPENSE_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ခေါင်စဉ်များ',
          icon: IconCategory,
          href: '/expense-headers',
          permission: hasPermission(userPermissions, EXPENSE_HEADER_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ခေါင်စဉ်ခွဲများ',
          icon: IconCategory,
          href: '/expense-subheaders',
          permission: hasPermission(userPermissions, EXPENSE_SUBHEADER_LIST_SK, isRootAdmin),
        },
      ]

    },
    {
      navlabel: true,
      icon: IconHomeCog,
      subheader: 'ဂိုဒေါင်/ဆိုင်များ',
      permission: [WAREHOUSE_LIST_SK, SHOP_LIST_SK, SUPPLIER_LIST_SK, BRAND_LIST_SK, REGION_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [
        {
          id: uniqueId(),
          title: 'ဂိုဒေါင်များ',
          icon: IconBuildingWarehouse,
          href: '/warehouses',
          permission: hasPermission(userPermissions, WAREHOUSE_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Regions',
          icon: IconMapPin,
          href: '/regions',
          permission: hasPermission(userPermissions, REGION_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'Brands',
          icon: IconBadge,
          href: '/brands',
          permission: hasPermission(userPermissions, BRAND_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ဆိုင်များ',
          icon: IconBuildingStore,
          href: '/shops',
          permission: hasPermission(userPermissions, SHOP_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'ရောင်းချသူများ',
          icon: IconBuildingFactory,
          href: '/suppliers',
          permission: hasPermission(userPermissions, SUPPLIER_LIST_SK, isRootAdmin),
        },
      ],
    },
    // {
    //   navlabel: true,
    //   icon: IconBuildingBank,
    //   subheader: 'ပေးချေမှု',
    //   permission: hasPermission(userPermissions, BANK_LIST_SK, isRootAdmin),
    //   items: [
    //     {
    //       id: uniqueId(),
    //       title: 'ဘဏ်များ',
    //       icon: IconBuildingBank,
    //       href: '/banks',
    //       permission: hasPermission(userPermissions, BANK_LIST_SK, isRootAdmin),
    //     },
    //   ],
    // },
    {
      navlabel: true,
      icon: IconScale,
      subheader: 'UOM Management',
      permission: [UOM_LIST_SK, UOM_CONVERSION_LIST_SK].some((perm) =>
        hasPermission(userPermissions, perm, isRootAdmin),
      ),
      items: [
        {
          id: uniqueId(),
          title: 'Unit of Measures',
          icon: IconScale,
          href: '/uoms',
          permission: hasPermission(userPermissions, UOM_LIST_SK, isRootAdmin),
        },
        {
          id: uniqueId(),
          title: 'UOM Conversions',
          icon: IconTransfer,
          href: '/uom-conversions',
          permission: hasPermission(userPermissions, UOM_CONVERSION_LIST_SK, isRootAdmin),
        },
      ],
    },
    {
      navlabel: true,
      icon: IconHistory,
      subheader: 'System Management',
      // The backend currently has no dedicated Version Control permission.
      permission: true,
      items: [
        {
          id: uniqueId(),
          title: 'Version Control',
          icon: IconHistory,
          href: '/versions',
          permission: true,
        },
      ],
    },
  ]
    .filter((section) => {
      // Keep only sections where navlabel is allowed
      if (section.permission === undefined) return true;
      if (typeof section.permission === 'boolean') return section.permission;
      if (typeof section.permission === 'string')
        return hasPermission(userPermissions, section.permission, isRootAdmin);
      return true;
    })
    .map((section) => {
      if (section.items) {
        const filteredItems = section.items.filter((item) => {
          if (item.permission === undefined) return true;
          if (typeof item.permission === 'boolean') return item.permission;
          if (typeof item.permission === 'string')
            return hasPermission(userPermissions, item.permission, isRootAdmin);
          return true;
        });
        return {
          ...section,
          items: filteredItems,
        };
      }
      return section;
    });

export default getMenuItems;
